import styled from "styled-components";

import { Icons } from "../Icons";

export const ShopModal = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 200px;
  z-index: 10;
  background-color: rgba(255, 255, 255, 0.95);
  display: flex;
  flex-direction: column;
  align-items: start;
  padding: 12px;
  gap: 12px;
`;

export const ModalTitle = styled.h3`
  font-size: 12px;
  margin: 0;
  font-weight: 400;
`;

export const CloseIcon = styled(Icons.Close)`
  width: 16px;
  height: 16px;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 0;
  background: transparent;
  border: 0;
  outline: 0;
  cursor: pointer;
`;

export const SelectButton = styled.button`
  border: 0;
  outline: 0;
  background-color: black;
  color: white;
  text-transform: uppercase;
  width: 100%;
  padding: 12px 0;
  font-weight: 400;
  border-radius: 0px;
  cursor: pointer;
  margin-top: auto;
`;

export const WorkTimeBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const WorkTimeTitle = styled.h4`
  font-size: 14px;
  margin: 0;
  font-weight: 400;
`;

export const WorkTime = styled.p`
  font-size: 12px;
  margin: 0;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.8);
  & > span {
    color: black;
  }
`;
